import {Component, OnInit} from '@angular/core'
import {ActivatedRoute, Router} from '@angular/router';

import {Message} from 'primeng/components/common/api';

import {CognitoUser, CognitoUserPool} from 'amazon-cognito-identity-js';

const USER_POOL_ID = 'eu-west-1_ASpJYc3mg';
const CLIENT_ID = '73vk3cbmodijbb4v0v6nclsbuo';

const userData: any = {
    UserPoolId: USER_POOL_ID,
    ClientId: CLIENT_ID
};

@Component({
    template: require('./confirm.component.pug')
})
export class ConfirmComponent implements OnInit {
    constructor(private route: ActivatedRoute, private router: Router) {
    }
    msgs: Message[] = [];

    ngOnInit(): void {
        let type = this.route.snapshot.queryParamMap.get('type');
        let username = this.route.snapshot.queryParamMap.get('user_name');
        let code = this.route.snapshot.queryParamMap.get('confirmation_code');
        console.log(type, username, code);
        let userPool = new CognitoUserPool(userData);
        let cognitoUser = new CognitoUser({Username: username, Pool: userPool});
        if (type === 'SignUp') {
            cognitoUser.confirmRegistration(code, true, (err, result) => {
                if (err) {
                    console.log(err);
                } else {
                    console.log(result);
                    this.router.navigate(['/signin']);
                }
            });
        } else if (type === 'ResendCode') {
        } else if (type === 'ForgotPassword') {
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/confirm.component.ts